import api, { errorHandler } from "../config/api";

export interface SendOtpPayload {
  email: string;
  purpose: "admin_register" | "admin_reset";
  phoneNumber?: string;
}

export interface ResetAdminPasswordPayload {
  email: string;
  otp: string;
  newPassword: string;
}

export const sendOtp = async (payload: SendOtpPayload) => {
  const storeResponse = await api().post<{
    message?: string;
    data?: {
      expiresInSeconds?: number;
      otpId?: number;
      stored?: boolean;
    };
  }>("/otp/store/", payload);
  const storeBody = storeResponse.data;
  const storeData = storeBody.data;

  if (!storeData?.stored) {
    return {
      message:
        storeBody.message ??
        "If this admin email is registered, a verification code has been sent.",
      expiresInSeconds: storeData?.expiresInSeconds,
    };
  }

  let message = storeBody.message ?? "Verification code stored";
  try {
    const emailResponse = await api().post<{
      message?: string;
      data?: { emailSent?: boolean; expiresInSeconds?: number };
    }>("/otp/send-email/", {
      email: payload.email,
      purpose: payload.purpose,
      otpId: storeData.otpId,
    });
    message = emailResponse.data?.message ?? message;
  } catch {
    message =
      "Verification code generated. Email could not be sent — check the otp table for testing.";
  }

  return {
    message,
    expiresInSeconds: storeData.expiresInSeconds,
  };
};

export const userForgotPassword = async (payload: ResetAdminPasswordPayload) => {
  const response = await api().post("/user/forgot-password/", payload);
  return {
    message: response.data?.message ?? "Password reset successfully",
  };
};

export { errorHandler };
